export default __webpack_public_path__ + "static/media/korok3.d59c6832.gif";